export default class SpeakAudioForm {
  public lang?: string
  public voice?: string
  public content: string
  public speed?: string
}
